module.exports = __webpack_public_path__ + "img/img-d45dc9.jpg";